module.exports = __webpack_public_path__ + "img/discover.901d3ac1.svg";